import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/atoms/JsonLdScript/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.24.5_react-dom@18.3.0_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/client/script.js");
